export { default as useProductsElasticSearchSuggestInputKeyboard } from './useProductsElasticSearchSuggestInputKeyboard';
